function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import AllhomesBreadcrumbs from '@domain-group/fe-co-allhomes-breadcrumbs';
import AllhomesPropertyOfTheWeek from '@domain-group/fe-co-allhomes-property-of-the-week';
import { ChevronLeftIcon, ChevronRightIcon } from '@domain-group/fe-co-icon';
import { AdSpot } from '@domain-group/fe-co-allhomes-ads';
import commonPropTypes from '../../common-prop-types';
import Locality from '../locality';
import Options from '../options';
import * as commonStyles from './common.style';
import * as styles from './desktop-browse-suburb.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DesktopBrowseSuburb = props => ___EmotionJSX("div", null, ___EmotionJSX("div", {
  css: styles.breadcrumbs
}, props.breadcrumbs.items.length > 0 && ___EmotionJSX(AllhomesBreadcrumbs, props.breadcrumbs)), ___EmotionJSX("div", {
  css: styles.body
}, ___EmotionJSX("div", {
  css: styles.bodyLeft
}, props.pow && ___EmotionJSX("div", {
  css: styles.pow1
}, ___EmotionJSX(AllhomesPropertyOfTheWeek, _extends({
  onClick: (listing, index) => {
    if (props.powOnClickHandler) {
      props.powOnClickHandler(listing, index);
    }
  }
}, props.pow))), props.browseOptions && ___EmotionJSX("div", {
  css: styles.browseOptions
}, ___EmotionJSX(Options, props.browseOptions)), ___EmotionJSX("div", {
  css: styles.advert
}, ___EmotionJSX(AdSpot, {
  gpt: {
    adId: 'adspot-300x250-pos1',
    strategy: 'window.onload'
  },
  adbridg: {
    id: 'adb-ah-idx-lhs'
  },
  className: "allhomes-browse-suburb__ad-1"
}))), ___EmotionJSX("div", {
  css: styles.bodyRight
}, ___EmotionJSX("div", {
  css: styles.upLevelContainer
}, props.parentLink && ___EmotionJSX("a", {
  css: styles.upLevel,
  href: props.parentLink.href
}, ___EmotionJSX(ChevronLeftIcon, {
  size: "custom",
  css: commonStyles.upLevelIcon
}), props.parentLink.name)), ___EmotionJSX("div", {
  css: styles.title
}, ___EmotionJSX("h1", {
  css: styles.titleHeading
}, props.heading.title), props.advancedSearchLink ? ___EmotionJSX("div", null, ___EmotionJSX("span", {
  css: commonStyles.titleSubheading
}, "Search in\xA0"), ___EmotionJSX("a", {
  css: commonStyles.titleSubheadingLink,
  href: props.advancedSearchLink
}, ___EmotionJSX("span", null, props.heading.title), ___EmotionJSX(ChevronRightIcon, {
  css: commonStyles.titleSubheadingIcon,
  size: "small"
}))) : ___EmotionJSX("p", {
  css: styles.titleSubheading,
  href: props.advancedSearchLink
}, props.heading.subtitle)), ___EmotionJSX("div", {
  css: styles.browseSuburbs
}, ___EmotionJSX(Locality, props.localities)))));
DesktopBrowseSuburb.propTypes = _objectSpread(_objectSpread({}, commonPropTypes), {}, {
  powOnClickHandler: PropTypes.func
});
DesktopBrowseSuburb.defaultProps = {
  powOnClickHandler: () => {}
};
export default DesktopBrowseSuburb;